module.exports = __webpack_public_path__ + "img/16.f6b66978.png";